import styled, { css } from 'styled-components';
import defaultAvatar from 'assets/user_vatar.jpg';
import logout from 'assets/svg/logout.svg';
import { animation } from 'utils';
import { currentContentConfig } from '../../utils/handleCurrentContentConfig';
import { pageContainerMixin } from 'styles/AppStyles';

export const Container = styled.div`
  background-color: #fff;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 3px 10px 0px;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 2;
`;

export const Header = styled.header`
  ${pageContainerMixin}
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Section = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 0.2rem 0;
  @media (max-width: 730px) {
    gap: 1rem;
  }
`;

export const Logo = styled.img.attrs(() => ({
  src: currentContentConfig.logo,
}))`
  width: 60px;
  @media (max-width: 450px) {
    height: 50px;
    width: 50px;
  }
`;

export const Avatar = styled.img.attrs(({ $avatar }) => ({
  src: $avatar || defaultAvatar,
}))`
  width: 50px;
  cursor: pointer;
  border-radius: 50%;
  @media (max-width: 450px) {
    height: 40px;
    width: 40px;
  }
`;

export const Title = styled.span`
  font-size: 1.3em;
  font-weight: 700;
  color: black;
  @media (max-width: 670px) {
    display: none;
  }
`;

export const Tabs = styled.div`
  display: flex;
`;

export const Tab = styled.div`
  display: block;
  position: relative;
  font-size: clamp(0.9rem, 2.5vw, 1.2rem);
  font-weight: 700;
  padding: 1rem;
  z-index: 1;
  cursor: pointer;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      transition: all 0.3s ease 0s;
      background-color: #e6f1ff;
      border-radius: 0.5rem;
    }
  }

  @media (max-width: 730px) {
    padding: 1.2rem 0.7rem 0.7rem;
  }
  @media (max-width: 450px) {
    padding: 1.2rem 0.4rem 0.7rem;
  }
`;

export const TabLabel = styled.span`
  ${({ $isActive }) =>
    $isActive &&
    css`
      border-bottom: 2px solid #000;
      padding-bottom: 0.4rem;
      @media (max-width: 450px) {
        padding-bottom: 0.2rem;
      }
    `};
`;

export const UserProfile = styled.div`
  position: relative;
  display: flex;
  @media (max-width: 1000px) {
    position: unset;
  }
`;

export const BackDrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: -1;
`;

export const Popover = styled.div`
  position: absolute;
  animation: ${animation.fadeIn} 0.5s;
  background-color: rgb(255, 255, 255);
  color: rgb(17, 25, 39);
  border-radius: 8px;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  top: 61px;
  right: -78px;
  @media (max-width: 1000px) {
    top: 70px;
    right: 2px;
  }
  @media (max-width: 450px) {
    top: 62px;
  }
`;

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-size: 1.1em;
  font-weight: 700;
  gap: 0.5rem;
  padding: 1.2rem 0 0.5rem;
  border-bottom: 1px solid gainsboro;
  width: 210px;
  @media (max-width: 670px) {
    width: 200px;
  }
`;

export const Label = styled.div`
  max-width: ${({ $isBreakWord }) => ($isBreakWord ? 'min-content' : 'unset')};
`;

export const CoinsContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 60px;
  margin: 0.5rem;
  gap: 0.5rem;
  padding: 0.5rem;
  color: #595c60;
  word-break: break-all;
`;

export const CoinsIcon = styled.img.attrs(() => ({
  src: currentContentConfig.goodsAssets.C,
}))`
  width: 20px;
`;

export const LogoutContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 1rem 3rem;
  font-weight: 600;
  margin: auto;
  cursor: pointer;
  transition: 0.2s;
  &:hover {
    transform: scale(1.05);
  }
`;

export const LogoutIcon = styled.img.attrs(() => ({
  src: logout,
}))`
  height: 15px;
  width: 15px;
`;

export const NavLinkWrapper = styled.div`
  a {
    text-decoration: none;
    color: inherit;
  }
`;
